import enUS from "antd/es/locale/en_US";
import itIT from "antd/es/locale/it_IT";

export const antdLocales = {
  en: enUS,
  it: itIT,
};
